// Import model
import { DataviewEstimateOptionsResponse } from '../models/DataviewEstimateOptionsResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { EstimateOptions } from '../models/EstimateOptions';
import { FilterEstimateOptionsRequest } from '../models/FilterEstimateOptionsRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { EstimateOptionsSerializer } from './EstimateOptionsSerializer';
import { FilterEstimateOptionsRequestSerializer } from './FilterEstimateOptionsRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewEstimateOptionsResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewEstimateOptionsResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewEstimateOptionsResponse instance
   */
  static deserialize(json: string): DataviewEstimateOptionsResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewEstimateOptionsResponse instance
   */
  static fromObject(obj: any): DataviewEstimateOptionsResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewEstimateOptionsResponse');
    }


    const instance: DataviewEstimateOptionsResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        EstimateOptionsSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterEstimateOptionsRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewEstimateOptionsResponse instances
   */
  static deserializeArray(json: string): DataviewEstimateOptionsResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewEstimateOptionsResponse instance to a JSON string
   */
  static serialize(instance: DataviewEstimateOptionsResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewEstimateOptionsResponse instance to a plain object
   */
  static toObject(instance: DataviewEstimateOptionsResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        EstimateOptionsSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterEstimateOptionsRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewEstimateOptionsResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewEstimateOptionsResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
